import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  CheckJoinEligibilityServiceRequest,
  CheckSnsDuplicateServiceRequest,
} from '@musinsa/services-curator';
import { checkJoinEligibilityService, checkSnsDuplicateService } from '@musinsa/services-curator';

export const joinFactory = createQueryKeys('join', {
  checkJoinEligibility: (params: CheckJoinEligibilityServiceRequest) => ({
    queryKey: [{ params }],
    queryFn: () => checkJoinEligibilityService(params),
  }),
  checkSnsDuplicate: (params: CheckSnsDuplicateServiceRequest) => ({
    queryKey: [{ params }],
    queryFn: () => checkSnsDuplicateService(params),
  }),
});
